// Firebase configuration for push notifications
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyB2x_5ruDG1pB1SVnjPFnHvF-K3o0oq2uI",
  authDomain: "taminzo-be.firebaseapp.com",
  projectId: "taminzo-be",
  storageBucket: "taminzo-be.firebasestorage.app",
  messagingSenderId: "382573666602",
  appId: "1:382573666602:web:b0c1c4bc0420e616237e53",
  measurementId: "G-CLQ8WHTSPK"
};

const VAPID_KEY = 'BMCOF8gyKSXIV0AWK2ftqQbXxOW-dmES0ucVHqkvae5MWSKCbI1p1paAQi8uyzKwUgWvNxpqMfycvGy-YHM1up8';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging: Messaging | null = null;

try {
  // Check if service workers are supported
  if ('serviceWorker' in navigator) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.warn('Firebase messaging not supported in this browser:', error);
}

export { messaging, VAPID_KEY, getToken, onMessage };
